import { ObservableValue } from "azure-devops-ui/Core/Observable";
import {
    Dropdown,
    IDropdownPivot,
    IWithPivotsChildProps,
    WithPivots
} from "azure-devops-ui/Dropdown";
import { IListBoxItem, ListBoxItemType } from "azure-devops-ui/ListBox";
import { DropdownSelection } from "azure-devops-ui/Utilities/DropdownSelection";
import { GroupedItemProvider } from "azure-devops-ui/Utilities/GroupedItemProvider";
import { AggregateItemProvider } from "azure-devops-ui/Utilities/AggregateItemProvider";
import * as React from "react";
import { dropdownItems } from "./Data";

export default class DropdownAdvancedExample extends React.Component {
    private dropdown = React.createRef<Dropdown>();
    private groups = [{ id: "first" }, { id: "second" }];

    // GroupedItemProvider cannot be passed in as a pivot's items prop, but it can be used to arrange the initial data.
    private pivot2Items: GroupedItemProvider = new GroupedItemProvider(
        [
            { id: "sixteenth", text: "sixteenth", groupId: "first" },
            { id: "header3", text: "Header 3", type: ListBoxItemType.Header, groupId: "first" },
            { id: "header4", text: "Header 4", type: ListBoxItemType.Header, groupId: "second" },
            { id: "seventeenth", text: "seventeenth", groupId: "second" }
        ],
        this.groups,
        true
    );

    private pivot3Items: IListBoxItem[] = [
        { id: "header5", text: "Header 5", type: ListBoxItemType.Header },
        { id: "eighteenth", text: "eighteenth" },
        { id: "nineteenth", text: "nineteenth" }
    ];

    private selection = new DropdownSelection();
    private selectedPivot = new ObservableValue<string>("one");
    private pivots = [
        {
            actions: [
                {
                    className: "flex-self-end",
                    iconProps: { iconName: "Clear" },
                    text: "Test Action"
                }
            ],
            filterPlaceholderText: "Search First Pivot",
            filteredNoResultsText: "Nothing Found In First Pivot",
            id: "one",
            items: dropdownItems,
            name: "One"
        },
        {
            id: "two",
            items: this.pivot2Items,
            name: "Two"
        },
        { id: "three", name: "Three", items: this.pivot3Items },
        { id: "Four", noItemsText: "No items in pivot four", items: [] }
    ];
    private provider = new AggregateItemProvider<IListBoxItem>();

    public constructor(props: {}) {
        super(props);
        this.pivots.forEach(pivot => {
            this.provider.push(pivot.items);
        });
        // Select the first item by default.
        this.selection.select(1);
    }

    public render() {
        return (
            <div style={{ margin: "8px" }}>
                <WithPivots
                    calloutProps={{ title: "Pivots Example" }}
                    onPivotClicked={this.onPivotClicked}
                    selectedPivot={this.selectedPivot}
                    pivots={this.pivots}
                >
                    {(props: IWithPivotsChildProps) => (
                        <Dropdown
                            ariaLabel="Advanced"
                            className="example-dropdown"
                            placeholder="Select an Option"
                            items={this.provider}
                            selection={this.selection}
                            ref={this.dropdown}
                            {...props}
                            filterPlaceholderText={
                                props.filterPlaceholderText || "Search Current Pivot"
                            }
                        />
                    )}
                </WithPivots>
            </div>
        );
    }

    private onPivotClicked = (pivot: IDropdownPivot) => {
        this.selectedPivot.value = pivot.id;
    };
}
